import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Holds the total issues count returned by the backend (`response.data.count`,
 * typed `number` in GetIssuesDataResponse). The reducer replaces the whole state
 * with the numeric payload. The initial value is the legacy `{}` placeholder,
 * preserved as-is for byte-identical runtime behaviour.
 */
type IssuesCountState = number;

const initialState: IssuesCountState = {} as IssuesCountState;

const issueCountSlice = createSlice({
  name: "issueCount",
  initialState,
  reducers: {
    setIssuesCount: (_state: IssuesCountState, action: PayloadAction<IssuesCountState>) => action.payload,
  },
});

export const { setIssuesCount } = issueCountSlice.actions;

export const issueCount = issueCountSlice.reducer;

export default issueCountSlice.reducer;
